import PlantCardDefault from './PlantCardDefault';

const PlantCardsSwitch = (props) => {
  const { design, plant, plantExtended, moduleBridgeHex } = props;

  switch (design) {
    case 1:
      return <div>Hola!</div>;
    default:
      return (
        <PlantCardDefault
          plant={plant}
          plantExtended={plantExtended}
          moduleBridgeHex={moduleBridgeHex}
        />
      );
  }
};

export default PlantCardsSwitch;
